import React, { useState } from "react";

import { Button, Modal, Container, Stack } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import DeleteForeverIcon from "@mui/icons-material/DeleteForeverRounded";

const DeleteAttachmentComp = ({
	open,
	handleClose,
	selectedDocument,
	documentName,
	toBeDelete,
	setToBeDelete,
	setAmenities,
	setAmenityEvents,
	setAccessInformation,
	amenitiesDocImage,
	updateAmenitiesDocImage,
	toBeDeleteEvent,
	setToBeDeleteEvent,
	event,
	setEvent,
	state,
	setState,
	locationIndex,
	availableAmenity,
	setAvailableAmenity,
	toBeDeleteAmenity,
	setToBeDeleteAmenity,
	toBeDeleteAccessInformation,
	setToBeDeleteAccessInformation,
	tempAccessInformation,
	setTempAccessInformation,
	checkNewAmenitiesWarning,
	setAmenityOptions,
}: any) => {
	const [isLoading, setLoading] = useState(false);

	const removeAmenityAccessNameByAccessInfoId = (id: any) => {
		if (state.newAvailableAmenities?.length) {
			state.newAvailableAmenities.forEach((amenity: any) => {
				if (amenity.locations.length) {
					amenity.locations.forEach((location: any) => {
						if (location.amenityAccessName?.id === id) {
							location.amenityAccessName.id = "";
							location.amenityAccessName.name = "";
						}
					});
				}
			});
		}
		return state.newAvailableAmenities || [];
	};

	const handleDelete = async () => {
		if (Object.keys(toBeDeleteEvent).length) {
			let arr = state.amenityEvents.filter((event: any) => event != toBeDeleteEvent);
			setState({ ...state, amenityEvents: arr });
			setAmenityEvents([...arr]);
			checkNewAmenitiesWarning(state.newAvailableAmenities, state.accessInformation, arr);
			setToBeDeleteEvent({});
			handleClose();
			return;
		}
		if (Object.keys(toBeDeleteAmenity).length) {
			let arr = state.newAvailableAmenities.filter((amenity: any) => amenity != toBeDeleteAmenity);
			setState({ ...state, newAvailableAmenities: arr });
			setAmenityOptions((prev: any) => [...prev, toBeDeleteAmenity.amenityType]);
			setAmenities([...arr]);
			checkNewAmenitiesWarning(arr, state.accessInformation, state.amenityEvents);
			setToBeDeleteAmenity({});
			handleClose();
			return;
		}
		if (Object.keys(toBeDeleteAccessInformation).length) {
			let arr = state.accessInformation.filter((amenity: any) => amenity != toBeDeleteAccessInformation);
			const amenities = removeAmenityAccessNameByAccessInfoId(toBeDeleteAccessInformation.id);
			setState({ ...state, accessInformation: arr, newAvailableAmenities: amenities });
			setAccessInformation([...arr]);
			setAmenities([...amenities]);
			checkNewAmenitiesWarning(state.newAvailableAmenities, arr, state.amenityEvents);
			setToBeDeleteAccessInformation({});
			handleClose();
			return;
		}
		if (toBeDelete.name && locationIndex >= 0 && availableAmenity.locations[locationIndex] && availableAmenity.locations[locationIndex].amenityPhotos.length) {
			const amenityPhotos = [...availableAmenity.locations[locationIndex].amenityPhotos];
			let arr = amenityPhotos.filter((item: any) => {
				return item.name != toBeDelete.name;
			});

			const locations = [...availableAmenity.locations];
			locations[locationIndex].amenityPhotos = arr;
			setAvailableAmenity({ ...availableAmenity, locations });
			setToBeDelete({});
			setLoading(false);
			handleClose();
			return;
		}
		if (Object.keys(toBeDelete).length !== 0 && locationIndex >= 0 && availableAmenity.locations[locationIndex] && availableAmenity.locations[locationIndex].amenityPhotos.length) {
			const amenityPhotos = [...availableAmenity.locations[locationIndex].amenityPhotos];
			updateAmenitiesDocImage({
				...amenitiesDocImage,
				amenityPhotos: amenitiesDocImage.amenityPhotos ? [...amenitiesDocImage.amenityPhotos, toBeDelete] : [toBeDelete],
			});
			setLoading(true);
			const remainingPhoto = amenityPhotos.filter((item: any) => {
				return item.fileName != toBeDelete.fileName;
			});
			const locations = [...availableAmenity.locations];
			locations[locationIndex].amenityPhotos = remainingPhoto;
			setAvailableAmenity({ ...availableAmenity, locations });
			setToBeDelete({});
		} else {
			if (
				selectedDocument.fileName &&
				locationIndex >= 0 &&
				availableAmenity?.locations &&
				availableAmenity?.locations[locationIndex] &&
				availableAmenity?.locations[locationIndex]?.additionalAmenitiesDocument?.length &&
				documentName === "additionalAmenitiesDocument"
			) {
				setLoading(true);
				const additionalAmenitiesDocument = [...availableAmenity.locations[locationIndex].additionalAmenitiesDocument];
				let arr = additionalAmenitiesDocument.filter((item: any) => {
					return item.fileName != selectedDocument.fileName;
				});
				const locations = [...availableAmenity.locations];
				locations[locationIndex].additionalAmenitiesDocument = arr;
				setAvailableAmenity({ ...availableAmenity, locations });
				setLoading(false);
				handleClose();
				return;
			}
			if (
				selectedDocument.fileName &&
				locationIndex >= 0 &&
				availableAmenity?.locations &&
				availableAmenity?.locations[locationIndex] &&
				availableAmenity?.locations[locationIndex]?.rulesAndRegulationDocuments?.length &&
				documentName === "rulesAndRegulationDocuments"
			) {
				setLoading(true);
				const rulesAndRegulationDocuments = [...availableAmenity.locations[locationIndex].rulesAndRegulationDocuments];
				let arr = rulesAndRegulationDocuments.filter((item: any) => {
					return item.fileName != selectedDocument.fileName;
				});
				const locations = [...availableAmenity.locations];
				locations[locationIndex].rulesAndRegulationDocuments = arr;
				setAvailableAmenity({ ...availableAmenity, locations });
				setLoading(false);
				handleClose();
				return;
			}
			if (selectedDocument.name && tempAccessInformation?.accessInformationRulesAndRegulationDocuments?.length && documentName === "accessInformationRulesAndRegulationDocuments") {
				setLoading(true);
				let arr = tempAccessInformation.accessInformationRulesAndRegulationDocuments.filter((item: any) => {
					return item.name != selectedDocument.name;
				});
				setTempAccessInformation({ ...tempAccessInformation, accessInformationRulesAndRegulationDocuments: arr });
				setLoading(false);
				handleClose();
				return;
			}
			if (selectedDocument.name && tempAccessInformation?.accessForm?.length && documentName === "accessForm") {
				setLoading(true);
				let arr = tempAccessInformation.accessForm.filter((item: any) => {
					return item.name != selectedDocument.name;
				});
				setTempAccessInformation({ ...tempAccessInformation, accessForm: arr });
				setLoading(false);
				handleClose();
				return;
			}
			if (event?.newsLetterNotificationFiles && event?.newsLetterNotificationFiles?.length && documentName === "newsLetterNotificationFiles") {
				setLoading(true);
				if (selectedDocument.name) {
					let arr = event.newsLetterNotificationFiles.filter((item: any) => {
						return item.name != selectedDocument.name;
					});
					setEvent({ ...event, newsLetterNotificationFiles: arr });
				} else {
					let arr = event.newsLetterNotificationFiles.filter((item: any) => {
						return item.fileName != selectedDocument.fileName;
					});
					setEvent({ ...event, newsLetterNotificationFiles: arr });
				}
				setLoading(false);
				handleClose();
				return;
			}
			setLoading(true);
			updateAmenitiesDocImage({
				...amenitiesDocImage,
				[documentName]: amenitiesDocImage[documentName] ? [...amenitiesDocImage[documentName], selectedDocument] : [selectedDocument],
			});
			if (documentName === "accessForm" || documentName === "accessInformationRulesAndRegulationDocuments") {
				let arr = tempAccessInformation[documentName].filter((item: any) => {
					return item.fileName != selectedDocument.fileName;
				});
				setTempAccessInformation({ ...tempAccessInformation, [documentName]: arr });
			} else if (documentName === "newsLetterNotificationFiles") {
				let arr = event[documentName].filter((item: any) => {
					return item.fileName != selectedDocument.fileName;
				});
				setEvent({ ...event, [documentName]: arr });
			} else {
				const locations = [...availableAmenity?.locations];
				let arr = locations[locationIndex][documentName].filter((item: any) => {
					return item.fileName != selectedDocument.fileName;
				});
				locations[locationIndex][documentName] = arr;
				setAvailableAmenity({ ...availableAmenity, locations });
			}
		}
		setLoading(false);
		handleClose();
	};
	const onClose = () => {
		handleClose();
	};

	return (
		<Modal open={open} onClose={onClose}>
			<Container className="modal-container-style-amenity">
				<div className="modal-wrapper-doc">
					<Stack
						style={{
							alignItems: "center",
							gap: "12px",
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between"
					>
						<DeleteForeverIcon style={{ color: "#F44336", fontSize: "58px", border: "1px solid #EF5350", borderRadius: "50%", padding: "10px" }} />
						<div>
							<h2 style={{ color: "#3E3E3E" }}>Are you sure you want to delete?</h2>
							<p style={{ color: "#787878" }}>This item will be deleted once you save information. It cannot be retrieved afterward</p>
						</div>
					</Stack>

					<Stack style={{ marginTop: "24px" }} direction={"row"} spacing={1} justifyContent="flex-end">
						{!isLoading ? (
							<>
								<Button onClick={() => onClose()} variant="outlined">
									No
								</Button>
								<Button onClick={handleDelete} variant="contained">
									Yes
								</Button>
							</>
						) : (
							<LoadingButton loading loadingIndicator="Deleting..." variant="outlined">
								Deleting Data
							</LoadingButton>
						)}
					</Stack>
				</div>
			</Container>
		</Modal>
	);
};
export default DeleteAttachmentComp;
